import { RefreshCwIcon } from "lucide-react";
import type { ComponentProps } from "react";
import { Button } from "./button";

/** A labeled refresh action. Callers own fetching and the meaning of the label. */
export function RefreshButton({
  children = "Refresh",
  variant = "quiet",
  size = "sm",
  ...props
}: ComponentProps<typeof Button>) {
  return (
    <Button type="button" variant={variant} size={size} {...props}>
      <RefreshCwIcon aria-hidden="true" className="size-4" />
      {children}
    </Button>
  );
}
